import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import {
    Button, Modal, ModalBody, ModalFooter, ModalHeader, Input, Form, Label, NavLink, Badge
} from 'reactstrap';
import { clearSession } from '../../session';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ReactQuill from 'react-quill';

const all_hero_images = ["https://www.w3schools.com/html/mov_bbb.mp4", "https://www.history.com/.image/ar_1:1%2Cc_fill%2Ccs_srgb%2Cfl_progressive%2Cq_auto:good%2Cw_1200/MTU3ODc5MDg2OTY2NTgwOTU5/chicago-hero.jpg",
  "https://11pt5z46nuudt9qxx2knwgff-wpengine.netdna-ssl.com/wp-content/uploads/2019/09/VM-JMKE-Photography-Aerial-Skyline5-1024x768.jpg", "https://filmdaily.co/wp-content/uploads/2021/01/twice-lede.jpg",
  "https://www.gannett-cdn.com/presto/2020/07/13/PMJS/ef158586-e830-4234-a85c-98e42aed3df2-Alumni.jpg", "https://cdn.britannica.com/59/94459-050-DBA42467/Skyline-Chicago.jpg"];



const modules = {
  toolbar: [
    [{ 'header': [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    ['link'],
    ['clean']
  ],
};

const formats = [
  'header',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link'
];

const deepCopyFunction = (inObject) => {
    let outObject, value, key
  
    if (typeof inObject !== "object" || inObject === null) {
      return inObject // Return the value if inObject is not an object
    }
  
    // Create an array or object to hold the values
    outObject = Array.isArray(inObject) ? [] : {}
  
    for (key in inObject) {
      value = inObject[key]
  
      // Recursively (deep) copy for nested objects, including arrays
      outObject[key] = deepCopyFunction(value)
    }
  
    return outObject
  }

export default class UserAccounts extends React.Component {
    constructor(props) {
        super(props);
        this.state = { users: [],showUpdateUserRoleModal:false, temp_user:{roles:[]}, user_type:"", current_user: { id: "0", name: "", email: "", intro_en: "", intro_ch: "", contact_email: "", job: "", image: "", role: 5 }, show_user_modal: false };
        this.myEditor = React.createRef();

    }
    componentDidMount() {
        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/get_all_users", Qs.stringify({
            token: session.ch_admin_token
        })).then(res => {
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                let users = res.data.data;
                this.setState({ users: users });
            }
        });
    }

    handleUserAction(e, action_name, uid) {
        if (action_name === "update_user_role") {
            let role = parseInt(e.target.value);
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/update_user_role", Qs.stringify({
                token: session.ch_admin_token,
                uid: uid,
                role: role
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let users = this.state.users;
                    for (let i = 0; i < users.length; i++) {
                        if (users[i].id === uid) {
                            users[i].role = role;
                            break;
                        }
                    }
                    this.setState({ users: users });
                }
            });

        }
        else if (action_name === "update_user_admin") {
            let role = parseInt(e.target.value);
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/update_user_admin", Qs.stringify({
                token: session.ch_admin_token,
                uid: uid,
                is_admin: role
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let users = this.state.users;
                    for (let i = 0; i < users.length; i++) {
                        if (users[i].id === uid) {
                            users[i].is_admin = role;
                            break;
                        }
                    }
                    this.setState({ users: users });
                }
            });

        }
        else if (action_name === "save_update_user_profile") {
            let session = window.localStorage;
            let current_user = this.state.current_user;
            let editor_current=this.myEditor.current;
            let introduction="";
            if(editor_current!==null)
            {
                let editor = this.myEditor.current.getEditor();
                 introduction = editor.root.innerHTML;
            }
            
            if(current_user.lang===1)
            {
                current_user.intro_en=introduction;
            }
            else
            {
                current_user.intro_ch=introduction;
            }

            axios.post(session.ch_action_url + "/action/update_user_profile_info", Qs.stringify({
                token: session.ch_admin_token,
                user: JSON.stringify(current_user)
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {         
                    let users=this.state.users;           
                    for (let i = 0; i < users.length; i++) {
                            if (users[i].id === current_user.id) {
                                users[i].name = current_user.name;
                                users[i].image = current_user.image;
                                //users[i].role = current_user.role;
                                users[i].intro_en = current_user.intro_en;
                                users[i].intro_ch = current_user.intro_ch;
                                users[i].job = current_user.job;
                                users[i].contact_email = current_user.contact_email;
                                break;
                            }
                        }
                    
                    this.setState({ users: users, show_user_modal: false });
                }
            });
        }
        else if (action_name === "add_new_user_from_admin") {
            let session = window.localStorage;
            let current_user = this.state.current_user;
            current_user.role = current_user.role.toString();
            axios.post(session.ch_action_url + "/action/add_user_from_admin", Qs.stringify({
                token: session.ch_admin_token,
                user: JSON.stringify(current_user)
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let user = res.data.data;
                    user.roles=["member"]
                    let users = this.state.users;
                    if (current_user.id === "0") {
                        users.push(res.data.data);
                    }
                    else {
                        for (let i = 0; i < users.length; i++) {
                            if (users[i].id === current_user.id) {
                                users[i].name = user.name;
                                users[i].image = user.image;
                                users[i].role = user.role;
                                users[i].intro_en = user.intro_en;
                                users[i].intro_ch = user.intro_ch;
                                users[i].job = user.job;
                                
                                users[i].contact_email = user.contact_email;
                                break;
                            }
                        }
                    }
                    this.setState({ users: users, show_user_modal: false });
                }
            });
        }
        else if (action_name === "approve_user") {
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/approve_pending_user", Qs.stringify({
                token: session.ch_admin_token,
                uid: uid
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let users = this.state.users;
                    for (let i = 0; i < users.length; i++) {
                        if (users[i].id === uid) {
                            users[i].status = 1;
                            break;
                        }
                    }
                    this.setState({ users: users });
                }
            });
        }
        else if (action_name === "delete_user") {
            Swal.fire({
                title: "Deletion",
                text: "Are you sure to delete this user?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
            }).then((result) => {
                if (result.value) {
                    let session = window.localStorage;
                    axios.post(session.ch_action_url + "/action/delete_single_user", Qs.stringify({
                        token: session.ch_admin_token,
                        uid: uid
                    })).then(res => {
                        if (res.data.status === -1) {
                            clearSession();
                        }
                        else if (res.data.status === 0) {
                            Swal.fire(
                                'Operation Failed!',
                                res.data.info,
                                'error');
                        }
                        else {
                            let users = this.state.users;
                            users = users.filter(user => (user.id != uid));
                            this.setState({ users: users });
                        }
                    });
                }
            });


        }
    }

    handleAddNewImage() {
        let final_this = this;
        let fileInput = document.getElementById('upload_member_image');
        if (fileInput.files != null && fileInput.files.length === 1) {
            let reader = new FileReader();
            reader.onload = function (e) {
                let image = new Image();
                image.src = e.target.result;
                image.onload = function () {
                    let height = this.height;
                    let width = this.width;
                    // while (width >= 1080 || height >= 1080) {
                    //     height = height / 2;
                    //     width = width / 2;
                    // }
                    let mainCanvas = document.createElement("canvas");
                    mainCanvas.width = 200;
                    mainCanvas.height = 200;
                    var ctx = mainCanvas.getContext("2d");
                    ctx.drawImage(image, 0, 0, mainCanvas.width, mainCanvas.height);
                    let image_64 = mainCanvas.toDataURL("image/jpeg");
                    mainCanvas.remove();
                    let current_user = final_this.state.current_user;
                    current_user.image = image_64;
                    final_this.setState({ current_user: current_user });
                };
                fileInput.value = "";
            };
            reader.readAsDataURL(fileInput.files[0]);
        }
        else {
            Swal.fire(
                'Operation Failed!',
                "You have not select image!",
                'error');
            return;
        }
    }

    handleShowUploadImage() {
        let fileInput = document.getElementById('upload_member_image');
        fileInput.click();
    }

    handleUpdateCurrentUser(e, action_name) {
        let current_user = this.state.current_user;
        if (action_name === "update_role") {
            current_user.role = parseInt(e.target.value);
        } else if (action_name === "update_name") {
            current_user.name = e.target.value;
        }
        else if (action_name === "update_job") {
            current_user.job = e.target.value;
        } else if (action_name === "update_contact_email") {
            current_user.contact_email = e.target.value;
        } else if (action_name === "update_intro_en") {
            current_user.intro_en = e.target.value;
        }
        else if (action_name === "update_intro_ch") {
            current_user.intro_ch = e.target.value;
        }
        else if (action_name === "update_account") {
            current_user.email = e.target.value;
        }
        else if(action_name==="update_current_user_lang")
        {
            current_user.lang=current_user.lang===1?2:1;
        }
        this.setState({ current_user: current_user });

    }

    setCurrentUser(user) {
        let current_user=deepCopyFunction(user);
        current_user.lang=1;
        this.setState({ current_user: current_user, show_user_modal: true });
    }

    handleUpdateUserInfo(action_name, value){
        if(action_name==="update_user_role")
        {
            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/update_user_roles", Qs.stringify({
                token: session.ch_admin_token,
                uid: this.state.temp_user.id,
                roles: JSON.stringify(this.state.temp_user.roles)
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let users = this.state.users;
                    for (let i = 0; i < users.length; i++) {
                        if (users[i].id === this.state.temp_user.id) {
                            users[i].roles = deepCopyFunction(this.state.temp_user.roles);
                            break;
                        }
                    }
                    this.setState({ users: users, temp_user:{roles:[]}, showUpdateUserRoleModal:false});
                }
            });
        }
        else if(action_name==="close_update_user_role")
        {
            this.setState({temp_user:{roles:[]}, showUpdateUserRoleModal:false});

        }
        else if(action_name==="show_update_user_role_modal")
        {
            this.setState({temp_user:deepCopyFunction(value), showUpdateUserRoleModal:true});
        }
        else if(action_name==="set_select_role")
        {
            let temp_user=this.state.temp_user;
            if(temp_user.roles.includes(value)&&temp_user.roles.length>1)
            {
                let index = temp_user.roles.indexOf(value);
                if (index > -1) {
                    temp_user.roles.splice(index, 1);
                }
            }
            else
            {
                temp_user.roles.push(value);
            }
            this.setState({temp_user:temp_user});
        }
    }

    isConductor_Advisor(roles)
    {
        if(roles===undefined)
        {
            return false;
        }
        if(roles.includes("conductor")||roles.includes("advisor")||roles.includes("instructor"))
        {
            return true;
        }
        return false;
    }

    render() {
        return <Fragment>
            <div className="p-2">
                <input type="file" style={{ display: "none" }} id="upload_member_image" accept="image/png, image/gif,image/jpg, image/jpeg, image/bmp, image/x-icon" onChange={(e) => this.handleAddNewImage()} />
                <div className="mb-3 mt-2 card p-2" style={{ maxWidth: "900px", margin: "auto" }}>
                    <div className="d-flex mb-3">
                        <Button size="sm" className="form-control" color="first" onClick={e => this.setState({ show_user_modal: true, current_user: { id: "0", name: "", intro_en: "", intro_ch: "", contact_email: "", job: "", image: "", role: 5 } })}>{"Add New Member (PWD: huaxia_99)"}</Button>
                    </div>
                    <div className="d-flex pb-2">
                        <Button size="sm" className="ml-2" color={this.state.user_type===""?"danger":"dark"} onClick={e => this.setState({user_type:""})} >All Users</Button>
                        <Button size="sm" className="ml-2" color={this.state.user_type==="conductor"?"danger":"dark"} onClick={e => this.setState({user_type:"conductor"})} >Conductor</Button>
                        <Button size="sm" className="ml-2" color={this.state.user_type==="advisor"?"danger":"dark"} onClick={e => this.setState({user_type:"advisor"})} >Advisor</Button>
                        <Button size="sm" className="ml-2" color={this.state.user_type==="instructor"?"danger":"dark"} onClick={e => this.setState({user_type:"instructor"})} >Instructor</Button>
                        <Button size="sm" className="ml-2" color={this.state.user_type==="committee"?"danger":"dark"} onClick={e => this.setState({user_type:"committee"})} >Committee</Button>
                        <Button size="sm" className="ml-2" color={this.state.user_type==="member"?"danger":"dark"} onClick={e => this.setState({user_type:"member"})} >Just Member</Button>
                    </div>
                    {this.state.users.length > 0 && this.state.users.map(user => {
                        if(user.roles.includes(this.state.user_type)||this.state.user_type==="")
                        {return <div className="d-flex align-items-center justify-content-between pb-3 pt-3" style={{ borderBottom: "1px solid gray" }}>
                            <div className="d-flex" onClick={(e) => this.setCurrentUser(user)}>
                                <div className="d-flex align-items-center">
                                    <div className="avatar-icon-wrapper mr-2">
                                        <div className="avatar-icon"><img alt="..." src={user.image} /></div>
                                    </div>
                                    <div>
                                        <a href="#/" onClick={e => e.preventDefault()} className="font-weight-bold text-black" title="...">{user.name}</a>
                                        <span className="text-black-50 d-block">{user.email}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center">
                                {user.status === 0 &&
                                    <div>
                                        <Badge color="warning" className="text-success font-size-xs font-weight-normal py-1 h-auto px-3 badge-pill">
                                            Pending
                                  </Badge>
                                        <Button size="sm" color="neutral-danger" className="ml-4" onClick={() => this.handleUserAction(null, "approve_user", user.id)}>Approve</Button>
                                        <Button size="sm" color="neutral-dark" className="ml-4" onClick={() => this.handleUserAction(null, "delete_user", user.id)}>Deny</Button>
                                    </div>}
                                {user.status === 1 && <div className="d-flex align-items-center mr-3">
                                    <select type="select" className="px-4  badge badge-primary badge-pill" value={"" + user.is_admin} onChange={e => this.handleUserAction(e, "update_user_admin", user.id)} key={"member_role_admin" + user.id} style={{ border: "none", width:"110px" }}>
                                        <option value="1">Admin</option>
                                        <option value="0">Not Admin</option>
                                    </select>
                                </div>}
                                {user.status === 1 && <div className="d-flex align-items-center mr-3" style={{cursor:"pointer"}} onClick={(e)=>this.handleUpdateUserInfo("show_update_user_role_modal", user)}>
                                   {false&&<select type="select" className="px-4  badge badge-warning badge-pill" value={"" + user.role} onChange={e => this.handleUserAction(e, "update_user_role", user.id)} key={"member_role" + user.id} style={{ border: "none" }}>
                                        <option value="2">Conductor</option>
                                        <option value="3">Advisor</option>
                                        <option value="4">Instructor</option>
                                        <option value="5">Committee</option>
                                        <option value="6">Member</option>
                                    </select>}
                                    {user.roles.map((role)=>(
                                       <span className="px-4  badge badge-warning badge-pill" >{role}</span>
                                    ))}
                                </div>}
                                {user.status === 1 && <div className="d-flex align-items-center" style={{ cursor: "pointer" }}>
                                    <span type="select" className="px-4  badge badge-danger badge-pill" onClick={e => this.handleUserAction(e, "delete_user", user.id)} style={{ border: "none" }}>
                                        Delete
                                    </span>
                                </div>}
                            </div>
                        </div>}
                    })}
                </div>

                <Modal zIndex={2000} centered size="lg" isOpen={this.state.show_user_modal}>
                    <div className="modal-header">
                        <h5 className="modal-title">{"Member Editing"}</h5>
                        <div>
                            {this.state.current_user.id==="0"&&<Button className="ml-2 btn-primary" color="primary" onClick={(e) => this.handleUserAction(e, "add_new_user_from_admin")} size="sm" key="add_readme_button" id="add_readme_button" >{"Add"}</Button>}

                            {this.state.current_user.id!=="0"&&<Button className="ml-2 btn-primary" color="primary" onClick={(e) => this.handleUserAction(e, "save_update_user_profile")} size="sm" key="edit_readme_button" id="edit_readme_button" >{this.state.current_user.id==="0"?"Add":"Save"}</Button>}
                            <Button className="ml-2 btn btn-dark" onClick={(e) => this.setState({ show_user_modal: false, current_user: { id: "0", name: "", intro_en: "", intro_ch: "", contact_email: "", job: "", image: "", role: 5 } })} size="sm" key="save_single_import_tab_button" id="save_single_import_tab_button" >Close</Button>
                        </div>
                    </div>
                    <ModalBody>
                        <div className="p-2 text-center rounded-circle" style={{ cursor: "pointer" }}>
                            <img src={this.state.current_user.image} style={{ width: "100px", height: "100px" }} onClick={(e) => this.handleShowUploadImage()} />
                        </div>
                        <div className="form-group">
                            <label for="about_us_title">User Account (Must Be Email)</label>
                            <input type="text" className="form-control" disabled={this.state.current_user.id === "0" ? false : true} id="current_member_account" value={this.state.current_user.email} onChange={(e) => this.handleUpdateCurrentUser(e, "update_account")} />
                        </div>
                        <div className="form-group">
                            <label for="about_us_title">Name</label>
                            <input type="text" className="form-control" id="current_member_name" value={this.state.current_user.name} onChange={(e) => this.handleUpdateCurrentUser(e, "update_name")} />
                        </div>
                        {!this.isConductor_Advisor(this.state.current_user.roles)&& <div className="form-group">
                            <label for="about_us_intro">Duty</label>
                            <input type="text" className="form-control" id="current_member_job" value={this.state.current_user.job} onChange={(e) => this.handleUpdateCurrentUser(e, "update_job")} />
                        </div>}

                        {!this.isConductor_Advisor(this.state.current_user.roles)&&<div className="form-group">
                            <label for="about_us_intro">Contact Email</label>
                            <input type="text" className="form-control" id="current_member_contact_email" value={this.state.current_user.contact_email} onChange={(e) => this.handleUpdateCurrentUser(e, "update_contact_email")} />
                        </div>}

                        {this.isConductor_Advisor(this.state.current_user.roles)&&<div className="form-group">                        
                           <select type="select" className="form-control" id="current_user_lang" value={this.state.current_user.lang} onChange={e => this.handleUpdateCurrentUser(e, "update_current_user_lang")}>
                                        <option value="1">EN</option>
                                        <option value="2">CH</option>
                                    </select>
                                    </div>}
                        {this.isConductor_Advisor(this.state.current_user.roles)&&
                            <ReactQuill ref={this.myEditor} className="my_post_editor" id="my_item_profile_editor" theme="snow" value={this.state.current_user === null ? "" :(this.state.current_user.lang===1?this.state.current_user.intro_en:this.state.current_user.intro_ch)} modules={modules} formats={formats} placeholder="Example placeholder..." />
                        }
                    </ModalBody>
                </Modal>
                <Modal zIndex={2000} isOpen={this.state.showUpdateUserRoleModal}>
                <div className="modal-header">
                    <h5 className="modal-title">Update User Role</h5>
                    <div>
                        <Button color="primary" className="ml-2" size="sm" onClick={() => this.handleUpdateUserInfo("update_user_role")}>Confirm</Button>
                        <Button color="dark" className="ml-2" size="sm" onClick={(e) => this.handleUpdateUserInfo("close_update_user_role")}>Close</Button>
                    </div>
                </div>
                <ModalBody>
                    <div className="d-flex align-items-center" style={{cursor:"pointer"}} onClick={() => this.handleUpdateUserInfo( "set_select_role", "conductor")}>
                            <FontAwesomeIcon icon={(this.state.temp_user.roles.includes("conductor")) ?["fas", "check-square"]:["far", "square"]} className="mr-2" />
                            <span>Conductor</span>
                     </div>
                     <div className="d-flex align-items-center" style={{cursor:"pointer"}} onClick={() => this.handleUpdateUserInfo( "set_select_role", "advisor")} >
                            <FontAwesomeIcon icon={(this.state.temp_user.roles.includes("advisor")) ?["fas", "check-square"]:["far", "square"]} className="mr-2" />
                            <span>Advisor</span>
                        </div>
                        <div className="d-flex align-items-center" style={{cursor:"pointer"}} onClick={() => this.handleUpdateUserInfo( "set_select_role", "instructor")} >
                            <FontAwesomeIcon icon={(this.state.temp_user.roles.includes("instructor")) ?["fas", "check-square"]:["far", "square"]} className="mr-2" />
                            <span>Instructor</span>
                        </div>
                        <div className="d-flex align-items-center" style={{cursor:"pointer"}} onClick={() => this.handleUpdateUserInfo( "set_select_role", "committee")} >
                            <FontAwesomeIcon icon={(this.state.temp_user.roles.includes("committee")) ?["fas", "check-square"]:["far", "square"]} className="mr-2" />
                            <span>Committee</span>
                        </div>
                        <div className="d-flex align-items-center" style={{cursor:"pointer"}}  onClick={() => this.handleUpdateUserInfo( "set_select_role", "member")} >
                            <FontAwesomeIcon icon={(this.state.temp_user.roles.includes("member")) ?["fas", "check-square"]:["far", "square"]}className="mr-2" />
                            <span>Just Member</span>
                        </div>
                </ModalBody>
            </Modal>
            </div>
        </Fragment>
    }

}